import { useQuery } from "@apollo/client";
import type { Connection, Organization, Project } from "@casey/db-types";
import { GET_ORGANIZATION_INTERVIEW_INVITES } from "../gql";

export interface OrganizationConnectionsData {
  organizationBySlug: Organization & {
    projects: {
      nodes: (Project & {
        connections: {
          nodes: Connection[];
        };
      })[];
    };
  };
}

export interface OrganizationConnectionsVariables {
  organizationSlug: string;
}

export function useOrganizationConnections(organizationSlug: string) {
  const { data, loading, error, refetch } = useQuery<
    OrganizationConnectionsData,
    OrganizationConnectionsVariables
  >(GET_ORGANIZATION_INTERVIEW_INVITES, {
    variables: { organizationSlug },
    skip: !organizationSlug,
    errorPolicy: "all",
  });

  // Flatten all interview invites from all projects
  const connections =
    data?.organizationBySlug?.projects?.nodes?.flatMap(
      (project) => project?.connections?.nodes || [],
    ) || [];

  // Find the first active invite (you might want to filter by specific criteria)
  const activeInvite =
    connections.find(
      (invite) => invite && !invite.archivedAt && !invite.expiresAt,
    ) || connections[0];

  return {
    data: data?.organizationBySlug,
    connections,
    activeInvite,
    loading,
    error,
    refetch,
  };
}
